// 在 Element Plus 安装前设置，确保导入调用和 this.$confirm 等调用一致。
export function enableMessageBoxDragging(messageBox) {
  for (const method of ['alert', 'confirm', 'prompt']) {
    const original = messageBox[method]
    messageBox[method] = (message, title, options, appContext) => {
      // 支持 confirm(message, options) 和 confirm(message, title, options)。
      if (title !== null && typeof title === 'object') {
        return original(message, { draggable: true, ...title }, options, appContext)
      }
      return original(message, title, { draggable: true, ...options }, appContext)
    }
  }
}
